import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import editDateIcon from "../../../assets/editDate.png";
import CargasTable from "../../../components/CargasTable";
import Pagination from "@mui/material/Pagination";
import useOrdersLoadStore from "../../../store/ordersLoadStore";
import useOrderLoadItemsFromApiStore from "../../../store/orderLoadItemsFromApiStore";
import { formatarValor } from "../../../components/OrderTable";
import OrderLoadDetails from "../../../components/OrderLoadDetails";
import useOrderItemsLoadStore from "../../../store/orderItemsLoadStore";
import { useAuth } from "../../../contexts/AuthContext";

const Carga = () => {
  const { getAllOrdersLoad, ordersLoad, getAllAgentOrdersLoad } =
    useOrdersLoadStore();
  const { getAllOrderLoadItemsFromApi, orderLoadItemsFromApi } =
    useOrderLoadItemsFromApiStore();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState(
    new Date().getFullYear().toString()
  );
  const { user } = useAuth();

  const { clearOrderItemsLoad } = useOrderItemsLoadStore();

  useEffect(() => {
    if (!user) return;
    console.log("user: ", JSON.stringify(user));
    if (user.accessType === "AGENT") {
      getAllAgentOrdersLoad();
      return;
    }
    getAllOrdersLoad();
  }, [getAllOrdersLoad, user, getAllAgentOrdersLoad]);

  useEffect(() => {
    getAllOrderLoadItemsFromApi();
  }, [getAllOrderLoadItemsFromApi]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleYearSelect = (year) => {
    setSelectedYear(year);
    setIsOpen(false);
  };

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 6;

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const filteredCargas = ordersLoad.filter((carga) => {
    const cargaYear = new Date(carga.createdAt).getFullYear();
    return cargaYear === parseInt(selectedYear);
  });
  const currentCargas = filteredCargas;
  const totalValueLoads = filteredCargas.reduce(
    (total, order) => total + parseFloat(order.outgoing_total),
    0
  );
  // const years = [
  //   ...new Set(
  //     currentCargas.map((carga) => new Date(carga.createdAt).getFullYear())
  //   ),
  // ];

  const years = [2030, 2029, 2028, 2027, 2026, 2025, 2024, 2023, 2022, 2021];

  const handleNavigate = () => {
    clearOrderItemsLoad();
    navigate("/cargas/nova-carga");
  };

  return (
    <>
      <div className="flex justify-between h-[40px] my-2">
        <div className="w-[210px]">
          {user && user.accessType !== "AGENT" && (
            <CustomButton
              onClick={handleNavigate}
              className="bg-primary text-white font-semibold"
            >
              Nova Carga
            </CustomButton>
          )}
        </div>
        <div className="relative z-[1000]">
          <button
            onClick={toggleDropdown}
            className="flex items-center h-[40px]"
          >
            <img className="h-[30px] w-[30px]" src={editDateIcon} alt="" />
            <span className="font-semibold w-[120px] text-center px-8 py-2 text-[#FF9533] bg-[#F2F2F2] rounded-md ml-4">
              {selectedYear}
            </span>
          </button>
          {isOpen && (
            <ul className="absolute mt-2 bg-white shadow-md rounded-md border border-gray-300 w-[120px]">
              {years.map((year) => (
                <li
                  key={year}
                  className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={() => handleYearSelect(year)}
                >
                  {year}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <CargasTable cargas={currentCargas} />

      <OrderLoadDetails
        qtd={filteredCargas.length ?? "Nenhuma carga"}
        total={formatarValor(totalValueLoads, "USD") ?? "$ 0,00"}
      />
    </>
  );
};

export default Carga;
